import { format } from 'date-fns'
import React from 'react'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import Button from '../../../../components/Template/Button'
import Flex from './Flex'

function YearPicker({
  finishDate,
  modifyWeek,
  className,
  size = 1,
  isChanging = false,
  print = false,
}: IYearPickerProps & IYearPickerDispatch) {
  return (
    <Flex
      justifyCenter={true}
      alignCenter={true}
      print={print}
      style={{
        fontSize: `${16 * size}px`,
        fontWeight: 500,
        marginRight: `${1.5 * size}em`,
      }}
    >
      <Button
        light={true}
        size={size}
        small={true}
        style={{ marginRight: `${15 * size}px` }}
        onClick={modifyWeek(-1)}
        className={`${className}-button-decrese`}
        isDisabled={isChanging}
      >
        <FiChevronLeft size={16 * size} />
      </Button>
      <div className={`${className}-label`}>{format(finishDate, 'YYYY')}</div>
      <Button
        light={true}
        small={true}
        size={size}
        style={{ marginLeft: `${15 * size}px` }}
        onClick={modifyWeek(1)}
        className={`${className}-button-increse`}
        isDisabled={isChanging}
      >
        <FiChevronRight size={16 * size} />
      </Button>
    </Flex>
  )
}

export default YearPicker

export interface IYearPickerProps {
  finishDate: Date
  className?: string
  isChanging: boolean
  print?: boolean
  size?: number
}

export interface IYearPickerDispatch {
  modifyWeek: (weeks: number) => () => void
}
